import { useQuery } from '@tanstack/react-query';
import { useSanityProduct } from 'hooks/product/useSanityProduct';
import { useReviewedProduct } from 'hooks/reviews/useReviewedProduct';
import {
  fetchReviewedProducts,
  REVIEWED_PRODUCTS_KEY,
} from 'hooks/reviews/useReviewedProducts';
import { useGlobals } from 'hooks/useGlobals';
import type { JunipProductReview } from 'types/reviews';
import { getRootProductSlug } from 'utils/reviews/getRootProductSlug';

import { ReviewedProductInfo } from './ReviewedProductInfo';

export interface ProductInfoFromReviewProps {
  review: JunipProductReview;
  slug?: never;
  isLight?: boolean;
}

export function ProductInfoFromReview({
  review,
  ...props
}: ProductInfoFromReviewProps) {
  const { productId } = review;
  const { data: globals } = useGlobals();

  const { data: reviewedProduct } = useQuery({
    queryKey: [REVIEWED_PRODUCTS_KEY],
    queryFn: fetchReviewedProducts,
    select: (products) =>
      productId != null
        ? products.find((product) => product.id === productId)
        : undefined,
  });

  const { data: singleProduct } = useReviewedProduct({
    productId: !reviewedProduct && productId ? productId.toString() : undefined,
  });

  const product = reviewedProduct || singleProduct;

  const productSlug = product?.remoteHandle
    ? (getRootProductSlug(
        globals.reviewsMainProductSlugs,
        product.remoteHandle,
      ) ?? product.remoteHandle)
    : undefined;

  const sanityProduct = useSanityProduct(productSlug);

  return (
    sanityProduct && <ReviewedProductInfo product={sanityProduct} {...props} />
  );
}
